import { useGetOpenBetsSummaryQuery } from '@/store/api/betApi';
import { Icons } from '@/utils/Icons';
import { Link } from 'react-router-dom';

type ExposureSummaryModalProps = {
  open: boolean;
  onClose: () => void;
};

const ExposureSummaryModal = ({ open, onClose }: ExposureSummaryModalProps) => {
  const { data, isFetching, isError } = useGetOpenBetsSummaryQuery(undefined, { skip: !open });
  const bets = data?.bets ?? [];
  // const { sportName } = useParams();

  //Above logic was causing issues on pages other than sport thats why I am keeping it static for now
  const sportName = 'Cricket';

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-start justify-center overflow-y-auto bg-black/55 sm:px-2 sm:py-4">
      <section className="mt-0 max-h-[calc(100vh-8px)] w-full max-w-[410px] overflow-hidden bg-surface shadow-xl sm:mt-0 sm:max-w-[460px] md:max-w-[520px] lg:max-w-[800px] xl:max-w-[60%] xl:mt-0">
        <div className="flex h-11 items-center justify-between bg-secondary px-2.5 text-body-inverse sm:px-3">
          <h2 className="text-base font-bold">My Market</h2>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 shrink-0 items-center justify-center"
            aria-label="Close exposure summary"
          >
            <Icons.close className="h-6 w-6" />
          </button>
        </div>

        <div className="max-h-[calc(100vh-52px)] overflow-auto md:p-2">
          <table className="w-full min-w-[300px] table-fixed border-collapse text-xs md:text-base">
            <colgroup>
              <col className="w-[23%]" />
              <col className="w-[34%]" />
              <col className="w-[31%]" />
              <col className="w-[12%]" />
            </colgroup>
            <thead>
              <tr className="border-b border-input-border-strong bg-slate-200 text-left">
                <th className="px-1.5 py-2 font-bold sm:px-2">Event Type</th>
                <th className="px-1.5 py-2 font-bold sm:px-2">Event Name</th>
                <th className="px-1.5 py-2 font-bold sm:px-2">Match Name</th>
                <th className="px-1.5 py-2 font-bold sm:px-2">Trade</th>
              </tr>
            </thead>
            <tbody className={'bg-zinc-100'}>
              {isFetching ? (
                <tr>
                  <td colSpan={4} className="px-2 py-8 text-center text-body-muted">
                    Loading open bets...
                  </td>
                </tr>
              ) : isError ? (
                <tr>
                  <td colSpan={4} className="px-2 py-8 text-center text-danger">
                    Unable to load open bets summary.
                  </td>
                </tr>
              ) : bets.length ? (
                bets.map((bet) => (
                  <tr
                    key={`${bet.eventId}-${bet.marketId}`}
                    className="border-b border-input-border-strong"
                  >
                    <td className="truncate px-1.5 py-2 capitalize sm:px-2">{sportName}</td>
                    <td className="px-1.5 py-2 font-medium text-blue-600 sm:px-2">
                      <Link
                        className="block truncate"
                        to={`/game-details/${sportName}/${bet.eventId}`}
                        onClick={onClose}
                      >
                        {bet.eventName}
                      </Link>
                    </td>
                    <td className="truncate px-1.5 py-2 sm:px-2">{bet.marketName}</td>
                    <td className="px-1.5 py-2 sm:px-2">{bet.betCount}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="px-2 py-8 text-center text-body-muted">
                    No open bets found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default ExposureSummaryModal;
